(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mdh-body-browse"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  const form=event.target.closest('[data-mdh-body-filter]');
  if(!form)return;
  event.preventDefault();
  const tags=Array.from(form.querySelectorAll('select')).map(select=>select.value).filter(Boolean);
  window.location.assign(form.dataset.baseUrl+(tags.length?'/'+tags.map(encodeURIComponent).join('+'):''));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdh-product-safety"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mdh-product-safety')) {
    customElements.define('mdh-product-safety', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        let hoverOpened = false;
        summary.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          hoverOpened = !details.open;
          details.open = true;
        });
        this.addEventListener('pointerleave', () => {
          if (hoverOpened && !this.contains(document.activeElement)) details.open = false;
          hoverOpened = false;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
